import { render, staticRenderFns } from "./DeliveryCalendarPage.vue?vue&type=template&id=7cedbcac"
import script from "./DeliveryCalendarPage.vue?vue&type=script&lang=ts"
export * from "./DeliveryCalendarPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports